// ATC Button for reference
const ATCButton = document.querySelector('#productATC');
// ATC Text Area for reference
const ATCTextArea = document.querySelector('#productATCText');

/************
 Product Swiper
 ************/

// setup product swiper
const productSwiper = new Swiper(document.querySelector(".productVisualSwiper"), {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
        nextEl: document.querySelector(".productVisualSwiper .nextEl"),
        prevEl: document.querySelector(".productVisualSwiper .prevEl"),
    },
    on: {
        slideChange: function () {
            // update the thumbnail active class
            document.querySelector(".productVisualThumbsSlide.active")?.classList.remove("active");
            document.querySelectorAll(".productVisualThumbsSlide")[this.realIndex]?.classList.add("active");

            // pause all videos
            document.querySelectorAll(".productVisualSwiperSlide video")?.forEach(element => {
                element.pause();
            });
        }
    }
});

// play video on slide play click
document.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
    element.addEventListener("click", function () {
        // get video
        const video = this.closest(".productVisualSwiperSlide").querySelector("video");

        if (video) {
            // remove play button if it hasn't already been removed
            this.querySelector(".productVisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();

        }
    });
});

// change slide on thumbnail click
document.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
    element.addEventListener("click", function () {
        // change slide
        productSwiper.slideTo(this.dataset.index - 1);
        // hide background images if shown
        document.querySelector('#productVisualSwiperImageOverlay').classList.remove('active');
    });
});

/************************
 Background Overlay image
 ************************/

// when background is clicked, update the product image
document.querySelectorAll('.productOptionItemValuesLabel').forEach(el => {
    if (!el.classList.contains('backgrounds')) return;
    el.addEventListener('click', function () {
        if (this.dataset.image !== "https://cdn.shopify.com/s/files/1/0055/0957/8803/") {
            document.querySelector('#productVisualSwiperImageOverlay').src = this.dataset.image;
            document.querySelector('#productVisualSwiperImageOverlay').classList.add('active');
        }

    });
})

// close background overlay when clicked
document.querySelector('#productVisualSwiperImageOverlay').addEventListener('click', function () {
    this.classList.remove('active');
});

/************
 Tab Content
 ************/
// information under ATC button
document.querySelectorAll('.productTabsSelectItem').forEach(tab => {
    tab.addEventListener('click', function () {
        if (this.classList.contains('active')) return;
        const infoName = this.dataset.name;
        this.closest('#productTabs').querySelectorAll('.active').forEach(el => el.classList.remove('active'));
        this.closest('#productTabs').querySelectorAll(`[data-name="${infoName}"]`).forEach(el => el.classList.add('active'));
    });
})

/****************
 Product Variants
 ****************/

// update active variant on input changes
document.querySelectorAll("#product input").forEach(function (element) {
    if (element.classList.contains('notOption')) return;
    element.addEventListener("change", function () {
        updateProduct();
        element.closest('.productOptionItem')?.querySelector('.active')?.classList.remove('active');
        element.parentElement.classList.add('active');
          console.log(product.id)
        // if input is number of pets, update how many pet inputs are shown
if (element.dataset.type === "number") {
  if (product.id == 8828250325210) {
    console.log('Im here');
    howManyInputs(5);
  } else {
    howManyInputs(element.value);
  }
}
        
        // Hide digital file upsell if digital file frame is selected
        handleDigitalFileUpsell();
    });
})

// how many pet inputs are shown, number of pets equals number of inputs
function howManyInputs(value) {
    if (!value) return;
    document.querySelectorAll('.productPhotoFormMore').forEach(section => {
        if (parseInt(section.dataset.number) <= value) {
            section.classList.add('active');
        } else {
            section.classList.remove('active');
        }
    })
}

// Handle digital file upsell visibility
function handleDigitalFileUpsell() {
    // Check if Digital File is selected in frame options
    const selectedOption = document.querySelector('#product input:checked[value*="Digital"]');
    const isDigitalFileSelected = selectedOption && selectedOption.value.toLowerCase().includes('digital');
    
    // Find the digital file upsell specifically
    document.querySelectorAll('.productUpsellsGroupItem').forEach(upsell => {
        const upsellText = upsell.querySelector('.productUpsellsGroupItemText')?.textContent?.toLowerCase();
        if (upsellText && upsellText.includes('digital')) {
            if (isDigitalFileSelected) {
                // Hide the digital file upsell when digital file frame is selected
                upsell.style.display = 'none';
                // Remove active state if it was toggled on
                upsell.classList.remove('active');
            } else {
                // Show the digital file upsell when other frame options are selected
                upsell.style.display = '';
            }
        }
    });
}

// get number of pets chose on reload
if(product.id == 8828250325210) {
  howManyInputs(5)
}else {
howManyInputs(document.querySelector('.productOptionItemValuesLabelInput[data-type="number"][checked]')?.value);
}

// Handle digital file upsell on page load
handleDigitalFileUpsell();
// update active variant
function updateProduct() {
    // collect options from inputs
    let options = [];
    document.querySelectorAll(`.productOptionItem`).forEach(group => {
        options.push(group.querySelector(`input:checked`).value);
    });

    // find new variant based on the options
    activeVariant = product.variants.find((variant) => {
        return JSON.stringify(variant.options) === JSON.stringify(options)
    });

    // check if variant wasn't found
    if (activeVariant === null || activeVariant === undefined) {
        ATCButton.disabled = true;
        ATCTextArea.textContent = "Not Available";
        return;
    }

    // find related variants
    let relatedVariants = product.variants.filter((variant) => {
        return variant.options[1] === activeVariant.options[1];
    });

    // update price differences
    updatePriceDifferences(relatedVariants);

    // update price
    document.querySelector("#productPriceReal").textContent = price(activeVariant.price);
    if (activeVariant.compare_at_price > activeVariant.price) {
        document.querySelector("#productPriceCompare").textContent = price(activeVariant.compare_at_price);
        document.querySelector("#productPriceSavings").textContent = `Save ${Math.round((activeVariant.compare_at_price - activeVariant.price) * 100 / activeVariant.compare_at_price)}%`;
    } else {
        document.querySelector("#productPriceCompare").textContent = "";
        document.querySelector("#productPriceSavings").textContent = "";
    }

    // check if the variant is in stock
    if (activeVariant.available) {
        ATCButton.classList.add("primary");
        ATCButton.disabled = false;
    } else {
        ATCButton.classList.remove("primary");
        ATCButton.disabled = true;
        ATCTextArea.textContent = "Sold Out";
    }

    // if variant has featured_image, slide to image
    if (activeVariant.featured_image) {
        productSwiper.slideTo(activeVariant.featured_image.position - 1);
    }

    // update url with variant id so the selected options are maintained on refresh
    let url = new URL(window.location.href);
    url.searchParams.set("variant", activeVariant.id);
    window.history.replaceState({}, "", url);
}

// update price differences over size images
function updatePriceDifferences(relatedVariants) {
    // hide all price differences
    document.querySelectorAll('.productOptionItemValuesLabelPrice')?.forEach(el => el.textContent = "");
    // sort through related variants and use options name to find and replace appropriate price difference
    for (let variant in relatedVariants) {
        if (relatedVariants[variant].id !== activeVariant.id) {
            if (relatedVariants[variant].price > activeVariant.price) {
                const selector = relatedVariants[variant].option1;
                if (document.querySelector(`.productOptionItemValuesLabelPrice[data-name='${selector}']`)) {
                    document.querySelector(`.productOptionItemValuesLabelPrice[data-name='${selector}']`).textContent = `+${price(relatedVariants[variant].price - activeVariant.price, true)}`;
                }
            }
        }
    }
}

/********************
 Cycle through Options
 *********************/

// keep track of the stage
let purchaseStage = 1;
// variable for track points, may be less than purchase stage
let trackStage = 1;
// get the product option section
const productOptionSection = document.querySelector('#productOption');
// process images
let processedImages = {};

// updating track of the stage
async function updateStage(advance = true) {

    // scroll track into options
    document.querySelector('#productContent').scrollIntoView({
        behavior: 'smooth'
    });
    // debugger
    // Handle dialog and "Add to Cart" button text/class based on product ID
    if (product.id == 8989936124122) {
        if (purchaseStage === 2 && advance) { // Upload step for this product
            // check if there are no photos uploaded
            if (Object.keys(processedImages).length === 0) {
                openDialog(document.querySelector('#productNoPhotoDialog'));
            }
        }
        } // Close the product.id == 8989936124122 block here for dialog logic

    // decrement or increment stage
    advance ? purchaseStage++ : purchaseStage--;
    advance ? trackStage++ : trackStage--;

    // Set button text based on current stage for this product (after stage update)
    if (product.id == 8989936124122) {
        if (purchaseStage === 3) {
            ATCTextArea.textContent = "Add to Cart";
            ATCButton.classList.add('finalStage');
        } else {
            ATCTextArea.textContent = "Next Step";
            ATCButton.classList.remove('finalStage');
        }
    } else { // Logic for other products (adjusted for post-increment purchaseStage)
        if (purchaseStage === 5 && advance) {
            ATCTextArea.textContent = "Add to Cart";
            ATCButton.classList.add('finalStage');

            // check if there are no photos uploaded
            if (Object.keys(processedImages).length === 0) {
                openDialog(document.querySelector('#productNoPhotoDialog'));
            }

        } else if (purchaseStage === 6 && !advance) {
            ATCTextArea.textContent = "Next Step";
            ATCButton.classList.remove('finalStage');
        }
    }

    // check if checkout is missing stage i.e. product does not have sizing option
    // if there is a missing option, skip to the next stage or the prior stage
    // trackStage does not update since stages are hard coded but track points are not
    if (!document.querySelector(`.productOptionTrackItem.productTrack-${purchaseStage.toString()}`)) {
        if (advance) {
            purchaseStage++;
        } else {
            purchaseStage--;
        }
    }

    // hide back button
    if (purchaseStage === 1) {
        document.querySelector("#productCycle").classList.remove("active");
    }

    // hide all sections
    productOptionSection.querySelectorAll('.productOptionTrackItem.active').forEach(el => el.classList.remove('active'));
    //reveal the current stage
    document.querySelectorAll(`.productOptionTrackItem.productTrack-${purchaseStage.toString()}`).forEach(el => el.classList.add('active'));


    // update track indicators
    document.querySelectorAll('.productTrackPointsItem.active').forEach(el => el.classList.remove('active'));
    document.querySelector(`.productTrackPointsItem.productTrack-${trackStage.toString()}`).classList.add('active');

    document.querySelectorAll('.productTrackPointsItem.complete').forEach(el => el.classList.remove('complete'));

    for (let i = 1; i < trackStage; i++) {
        document.querySelector(`.productTrackPointsItem.productTrack-${i.toString()}`).classList.add('complete');
    }

    // update track bar
    if (advance) {
        document.querySelector('#productTrackBar').classList.remove(`track-${trackStage !== 2 ? trackStage - 1 : ""}`);
        document.querySelector('#productTrackBar').classList.add(`track-${trackStage}`);
    } else {
        document.querySelector('#productTrackBar').classList.remove(`track-${trackStage + 1}`);
        document.querySelector('#productTrackBar').classList.add(`track-${trackStage !== 1 ? trackStage : ""}`);
    }

    // Update digital file upsell visibility when stage changes
    handleDigitalFileUpsell();

}

// attach listener to back button
document.querySelector('#productCyclePrev')?.addEventListener('click', () => {
    updateStage(false);
});

// ATC button is a toggle until last stage
ATCButton.addEventListener("click", async function () {
    // gift card or default product template, skip track
    if (this.classList.contains('productATCGift') || this.classList.contains('productATCDefault')) {
        await addToCart();
        return;
    }

    // Determine the next action based on the current purchaseStage
    if (product.id == 8989936124122) {
        if (purchaseStage === 1) { // From Sizing to Upload
            document.querySelector('#productCycle').classList.add('active');
            await updateStage(); // Increment to 2 (Upload)
        } else if (purchaseStage === 2) { // From Upload to Extras
            await updateStage(); // Increment to 3 (Extras)
        } else if (purchaseStage === 3) { // From Extras to Add to Cart
            await addToCart();
        }
    } else { // Original logic for other products (assuming a 4-step process before ATC)
        if (purchaseStage === 1) {
            document.querySelector('#productCycle').classList.add('active');
            await updateStage(); // Increment to 2
        } else if (purchaseStage === 2 || purchaseStage === 3 || purchaseStage === 4) {
            await updateStage(); // Increment to 3, 4, or 5
        } else if (purchaseStage === 5) { // Final stage for other products
            await addToCart();
        }
    }
});

/******
 Modals
 *******/

// photo guide modal
document.querySelector('#productPhotoTopGuide')?.addEventListener('click', function () {
    openDialog(document.querySelector('#productPhotoDialog'));
});

// closing the photo upload modal
document.querySelector('#productNoPhotoDialogReturn')?.addEventListener('click', function () {
    this.closest('dialog').close();
    document.querySelector('body').classList.remove('noScroll');
});

// photo upload modal adding photos
document.querySelector('#productNoPhotoFormInput')?.addEventListener('click', () => {
    // close this modal and open the photo upload modal
    document.querySelector('#productNoPhotoDialog').close();
    document.querySelector('body').classList.remove('noScroll');
    updateStage(false);
    document.querySelector('#productPhotoFormInputElement').click();
})

/***********************
 Image Upload and display
 ************************/


document.querySelectorAll('.productPhotoFormInputElement:not(.largeNumber)')?.forEach(input => {
    input.addEventListener(`change`, async function () {
        // get pet number
        let pet = this.closest('.productPhotoFormMore')?.dataset.number
            ? this.closest('.productPhotoFormMore').dataset.number : 1;
        try {
            let fileType = this.files[0].type.startsWith('image') ? 'image' : 'video';
            // create file label
            let label = fileType === 'image' ? "pet " : "video "

            /******************************************
             storing and locally previewing images/video
             ******************************************/

            storeImages(input, pet);

            /***********************
             processing media with api
             ************************/
            // add loading animation on loading buttons
            this.closest('.productPhotoFormInputText').classList.add('loading');
            //process image/video
            await processImage(this.files[0], label + pet + " URL", fileType);
            // if successful, change text
            this.previousElementSibling.textContent = fileType === 'image' ? "Change Image?" : "Change Video?";
            // remove loading animation on loading buttons
            this.closest('.productPhotoFormInputText').classList.remove('loading');
            // show confirmation message
            document.querySelector('#productPhotoConfirm').classList.add('active');
            setTimeout(() => {
                document.querySelector('#productPhotoConfirm').classList.remove('active');
            }, 2200);
        } catch (err) {
            console.log("Wrong file type", err);
        }
    });
});

// specific for large number of pets
let largeImageNumber = 1;
document.querySelector('.productPhotoFormInputElement.largeNumber')?.addEventListener(`change`, async function () {
    try {
        // image display
        storeImages(this, largeImageNumber);
        // add loading animation on loading buttons
        this.closest('.productPhotoFormInputText').classList.add('loading');
        //process image/video
        await processImage(this.files[0], `Image ${largeImageNumber}`);
        // update number, to keep track of images
        largeImageNumber++;
        // if successful, change text
        this.previousElementSibling.textContent = "Add More Images?";
        // remove loading animation on loading buttons
        this.closest('.productPhotoFormInputText').classList.remove('loading');
        // show confirmation message
        document.querySelector('#productPhotoConfirm').classList.add('active');
        setTimeout(() => {
            document.querySelector('#productPhotoConfirm').classList.remove('active');
        }, 2200);
    } catch (err) {
        console.log("Wrong file type", err);
    }
});

// process image api
async function processImage(file, pet, fileType = "image") {
    // upload to server
    let formData = new FormData();
    formData.set("UPLOADCARE_PUB_KEY", "c9537ba39f67b9ed12d6");
    formData.set("UPLOADCARE_STORE", "1");
    formData.set(fileType, file);

    try {
        const uploadPromise = await fetch(`https://upload.uploadcare.com/base/`, {
            method: "POST",
            body: formData
        });
        // process and assign data to object, separating pets by file
        const data = await uploadPromise.json();
        if (fileType === 'image') {
            processedImages[pet] = "https://ucarecdn.com/" + data.image + "/" + "@" + fileType;
        } else {
            processedImages[pet] = "https://ucarecdn.com/" + data.video + "/" + "@" + fileType;
        }
        console.log("upload completed")

    } catch (err) {
        console.log("Problem uploading file", err);
        alert("Problem uploading file, please try again");
    }
}

// separate storage for local media preview
const previewImages = {};

// process into base64 for local preview
function storeImages(input, key) {
    const file = input.files[0];
    if (file.type.startsWith('video')) key = 0;
    const reader = new FileReader();
    reader.onload = function (e) {
        previewImages[key] = e.target.result;
        showPreviews(Object.values(previewImages));
    };
    reader.readAsDataURL(file);
}

// dialog image preview element
const imageDisplay = document.querySelector(`#productPhotoFormInputDisplay`);

function showPreviews(files) {
    // clear files in cases some get removed
    let mediaUploads = [];
    const renderedFiles = files.map(file => {
        let imgNode;
        if (file.startsWith('data:image')) {
            imgNode = document.createElement('img');
        } else {
            imgNode = document.createElement('video');
            imgNode.setAttribute('controls', 'controls');
        }
        imgNode.setAttribute('src', file);
        imgNode.setAttribute('alt', 'pet image');

        mediaUploads.push(file);
        return imgNode;
    });
    // if more than one image, add class for better styling
    if (mediaUploads.length > 1) {
        imageDisplay.classList.add('multiple');
    } else {
        imageDisplay.classList.remove('multiple');
    }

    // fill out preview section
    imageDisplay.replaceChildren(...renderedFiles);
}

/*************
 Upsell Buttons
 **************/

// toggle on and off upsell
document?.querySelectorAll('.productUpsellsGroupItemButton').forEach(button => {
    button.addEventListener('click', function () {
        this.closest('.productUpsellsGroupItem').classList.toggle('active');
    });
});

/**************
 Product ATC
 ***************/

async function addToCart() {
    // add loading animation
    ATCButton.classList.add("loading");

    // collect properties
    let properties = {};

    // if not a gift card
    if (!ATCButton.classList.contains('productATCGift')) {

        //check if there is an image
        if (Object.keys(processedImages).length === 0) {
            // indicate no image added
            if (!ATCButton.classList.contains('productATCDefault')) {
                properties["Uploaded Photo"] = "No image added";
            }
        } else {
            Object.entries(processedImages).map(([key, value]) => {
                properties[key] = value.split("@")[0];
            })
        }

        // name/notes
        document.querySelectorAll('#productPhotoForm input').forEach(input => {
            if (input.type !== 'file') {
                if (input.value !== "") properties[input.name] = input.value;
            }
        });
    }
    if(product.id == 9055707922650){
        properties["Gender"] = document.querySelector('#productBackgrounds .productOptionItemValuesLabelInput:checked')?.value;
    }else{
    // background image
    properties["Background Image"] = document.querySelector('#productBackgrounds .productOptionItemValuesLabelInput:checked')?.value;
    }

    // existing customer notes
    document.querySelectorAll('#productExistingNotes input')?.forEach(input => {
        if (input.value !== "") properties[input.name] = input.value;
    });

    let formData = {
        items: [{
            quantity: 1,
            id: activeVariant.id,
            properties: properties
        }]
    };

    // check for upsells
    document.querySelectorAll('.productUpsellsGroupItem.active')?.forEach(upsell => {
        formData.items.push({
            quantity: 1,
            id: upsell.dataset.id
        });
    });

    // add product
    await addProduct(formData);

    // remove loading animation
    ATCButton.classList.remove("loading");

    // open cart
    await openCart();
};